import logo from '../../assets/logos/saccos_logo.png';

const sizeMap = {
  sm: { ring: 'w-10 h-10 border-[3px]', logo: 'w-5 h-5', text: 'text-xs' },
  md: { ring: 'w-16 h-16 border-[3px]', logo: 'w-8 h-8', text: 'text-sm' },
  lg: { ring: 'w-24 h-24 border-[4px]', logo: 'w-14 h-14', text: 'text-sm' },
};

export default function GlobalLoader({
  overlay = false,
  fullScreen = false,
  message = 'Loading…',
  size = 'md',
}) {
  const s = sizeMap[size];

  const wrapperClasses = fullScreen
    ? 'fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white'
    : overlay
    ? 'absolute inset-0 z-20 flex flex-col items-center justify-center bg-white/75 backdrop-blur-[2px]'
    : 'flex flex-col items-center justify-center py-10';

  return (
    <div className={wrapperClasses}>
      <style>{`
        @keyframes loaderSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes loaderCounterSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(-360deg); }
        }
      `}</style>

      <div className="flex flex-col items-center gap-3">
        <div
          className={`relative ${s.ring} rounded-full border-gray-200 border-t-brand-gold flex items-center justify-center bg-white shadow-lg`}
          style={{ animation: 'loaderSpin 1s linear infinite' }}
        >
          <img
            src={logo}
            alt="Uhamiaji SACCOS"
            className={`${s.logo} object-cover rounded-full border border-brand-navy/10`}
            style={{ animation: 'loaderCounterSpin 1s linear infinite' }}
          />
        </div>
        {message && (
          <span className={`${s.text} font-medium text-brand-navy/60`}>{message}</span>
        )}
      </div>
    </div>
  );
}
